export default __webpack_public_path__ + "media/what-are-you-doing-22344.0f03a377.mp3";